import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {UseLoader} from "../../../hooks/useLoader";
import {Dialog} from "primereact/dialog";
import {Toast} from "primereact/toast";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {PickList} from 'primereact/picklist';

import {AppContext} from "../../../context/appContext";

import {getSelectResourceTarget, onMoveSource, onMoveTarget} from "../../../api/contrato.service";

export const ModalAsociadoContrato = ({show, hide, contrato}) => {
    const [handleLoader] = UseLoader();
    const {user} = useContext(AppContext);
    const toast = useRef(null);
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    const getSelectResourceTargetPromise = async () => {
        try {
            const payload = {
                contratomarcoId: user.contratomarcoId
            }
            handleLoader(true)
            const respose = await getSelectResourceTarget(payload);
            handleLoader(false)
            return await respose.data;
        } catch (e) {
            console.log(e)
            handleLoader(false)
        }
    }

    useEffect(() => {
        if (user.contratomarcoId !== '' && user.contratomarcoId !== null && show) {
            getSelectResourceTargetPromise().then(r => {
                const data = r.data;
                setSource(data.resource);
                setTarget(data.target);
            })
        }
        return () => {
            if (user.contratomarcoId !== '' && user.contratomarcoId !== null && !show) {
                setSource([]);
                setTarget([]);
            }
        }
    }, [show]);


    const onMoveTargetPromise = (e) => {
        // agregar
        try {
            const obj = e.value[0];
            obj.contratomarcoId = user.contratomarcoId;
            handleLoader(true)
            onMoveTarget(obj).then(r => {
                const response = r.data;
                handleLoader(false)
                if (response.estado !== 200) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: response.mensaje ? response.mensaje : "Ha ocurrido un error",
                        life: 3000
                    });
                    return;
                }
                const newSource = source.filter(data => data.asociado_id !== obj.asociado_id);

                setSource(newSource);
                setTarget([...target, obj]);

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});

            })
        } catch (e) {
            console.log(e)
            handleLoader(false)
        }

    }

    const onMoveSourcePromise = (e) => {
        // eliminar
        try {
            const obj = e.value[0];
            obj.contratomarcoId = user.contratomarcoId;
            handleLoader(true)
            onMoveSource(obj).then(r => {
                const response = r.data;
                handleLoader(false)
                if (response.estado !== 200) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: response.mensaje ? response.mensaje : "Ha ocurrido un error",
                        life: 3000
                    });
                    return;
                }
                const newTaget = target.filter(data => data.asociado_id !== obj.asociado_id);
                setTarget(newTaget);
                setSource([...source, obj]);
                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});

            })
        } catch (e) {
            console.log(e)
            handleLoader(false)
        }
    }



    const itemTemplate = (item) => {
        return (
            <div className="flex min-w-0  w-full py-2 px-2 shadow-md bg-blueGray-100 border-0">
                <i className="fa fa-users mr-4 text-lightBlue-700" aria-hidden="true"></i>
                <h5 className="text-lightBlue-600 text-xs font-bold">{item.nombre}</h5>
            </div>
        );
    }
    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header={"Agregar afiliados: " + contrato}  visible={show}
                    style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <h6 className="title-modal">
                            Información de afiliados
                        </h6>

                        <div className="container mx-auto">
                            <div className="card">
                                <PickList source={source} target={target} itemTemplate={itemTemplate}
                                          sourceHeader={`Afiliados disponibles ${source.length}`} targetHeader={`Afiliados seleccionados ${target.length}`}
                                          onMoveToTarget={onMoveTargetPromise}
                                          onMoveToSource={onMoveSourcePromise}
                                          showSourceControls={false}
                                          showTargetControls={false}
                                          sourceStyle={{height: '342px'}} targetStyle={{height: '342px'}}
                                ></PickList>
                            </div>
                        </div>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    );
};

ModalAsociadoContrato.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func
};

